import { useEffect, useRef } from "react";

import { useTrackTrustpilotClick } from "../hooks/useTrackTrustpilotClick";
import { TrustpilotSection } from "../hooks/useZeroFranchiseTracking";

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement | null, reload: boolean) => void;
    };
  }
}

interface Props {
  trackingSection: TrustpilotSection;
}

export const TrustpilotMicroScoreWidget = ({ trackingSection }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useTrackTrustpilotClick({ ref, section: trackingSection });

  useEffect(() => {
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="fr-FR"
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="63346aa793282eadbbb54711"
      data-style-height="20px"
      data-style-width="232px"
      data-font-family="Montserrat"
      data-text-color="#0D0D0D"
    >
      <a href="https://fr.trustpilot.com/review/roole.fr" target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
